import {HeaderMenuIconDefaultBox} from "./header-menu-icon.default.box";

export const HeaderMenuIconBox = HeaderMenuIconDefaultBox;
